import DataNotFound from 'components/DataNotFound/DataNotFound';
import SegmentedDistributionBar from 'components/AiAnalytics/shared/SegmentedDistributionBar/SegmentedDistributionBar';
import { BaseWidget } from 'models/WidgetModel';
import React, { useMemo } from 'react';
import { mapCustomerEffortResponse } from './customerEffort.mapper';
import './CustomerEffort.scss';

const CustomerEffort: React.FC<BaseWidget> = ({ response }) => {
  const view = useMemo(() => mapCustomerEffortResponse(response), [response]);
  if (!view) return <DataNotFound />;

  const visibleTouchpoints = view.touchpoints.filter((touchpoint) => touchpoint.hasActivity);
  return (
    <div className="customer-effort">
      <section className="customer-effort__overall">
        <div className="customer-effort__section-header">
          <h3>Overall effort</h3>
          <span>{view.overall.highEffortPct}% high effort</span>
        </div>
        {view.overall.hasActivity ? (
          <SegmentedDistributionBar
            segments={view.overall.segments}
            accessibleLabel={`Overall effort: ${view.overall.segments
              .map(({ label, value }) => `${label} ${value}%`)
              .join(', ')}`}
          />
        ) : (
          <div className="customer-effort__no-activity">No activity</div>
        )}
      </section>
      {visibleTouchpoints.length > 0 ? (
        <section className="customer-effort__touchpoints">
          <h3>By touchpoint</h3>
          {visibleTouchpoints.map((touchpoint) => (
            <div className="customer-effort__touchpoint" key={touchpoint.touchpoint}>
              <div className="customer-effort__touchpoint-header">
                <span>{touchpoint.touchpoint}</span>
              </div>
              <SegmentedDistributionBar
                compact
                segments={touchpoint.segments}
                accessibleLabel={`${touchpoint.touchpoint}: ${touchpoint.segments
                  .map(({ label, value }) => `${label} ${value}%`)
                  .join(', ')}`}
              />
            </div>
          ))}
        </section>
      ) : null}
    </div>
  );
};

export default CustomerEffort;
